import { IAccount, currentPharmacyKey, tokenKey } from "../types";

export const parseJwtToken = (): IAccount  => {
  const token = sessionStorage.getItem(tokenKey);
  if (!token) {
    return { id: 0, name: "", email: "" } as IAccount;
  }

  const tokenParts = token.split('.');
  const tokenPayload = JSON.parse(atob(tokenParts[1]));

  return { 
    id: parseInt(tokenPayload.nameid),
    name: tokenPayload.unique_name, 
    email: tokenPayload.email 
  } as IAccount;
};

export const createApiHeaders = (addAuthorization: Boolean, addPharmacyCode: Boolean) : Record<string, string> => {
  const apiHeaders: Record<string, string> = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  if (addAuthorization) {
    apiHeaders.Authorization = `Bearer ${sessionStorage.getItem(tokenKey) ?? ''}`;
  }

  if (addPharmacyCode) {
    apiHeaders.X_PHARMACY_CODE = sessionStorage.getItem(currentPharmacyKey) ?? ''
  }

  return apiHeaders;
};